<template>
  <div class="item-row update-view" v-bind:class="{ active: show }">
    <b-row @click="showSpecificEntity(entity.URI, specificEntity[entity.URI])">
      <b-col>
        <b-row class="item-name-cont">
          <b-form-checkbox size="lg" class="master-checkbox darkbg" :checked="shouldSelected(entity)" v-on:change="toggleGroup(entity, $event)">
          </b-form-checkbox>
          <b-col cols="1" :aria-controls="entity.URI" @click="onShow" class="item-collapse-col">
            <span class="item-count">{{entity.sites.length}}</span>
          </b-col>
          <b-col :aria-controls="entity.URI" @click="onShow" class="item-collapse-col-name">
            <span class="item-name" v-html="entity.name"></span>
          </b-col>
        </b-row>


      </b-col>
    </b-row>
    <b-collapse :id="entity.URI" v-model="specificEntity[entity.URI]" class="entity-show" role="tabpanel" v-if="specificEntity[entity.URI]">
      <b-row v-for="(site, index) in entity.sites" :key="index" class="child-item-row">
        <b-col class="subitem-col">
          <b-form-checkbox class="darkbg" :disabled="hideselector" size="sm" :checked="site.selected" v-on:change="toggleSite(entity,site, $event)">
            <div>
              <span class="child-item-name" v-if="viewType == 'all'">{{site.name}}</span>
              <span class="child-item-name" v-else>{{site.siteName}}</span>
              <span class="version-log">
                <span class="version-from">{{site.old_version}}</span>
                <span class="version-arrow" v-if="site.new_version">
                  <right-arrow-icon class="icon-default right-arrow"></right-arrow-icon>
                </span>
                <span class="version-to" v-if="site.change_log"><a :href="site.change_log" target="_blank">{{site.new_version}}</a></span>
                <span class="version-to" v-if="site.new_version && !site.change_log">{{site.new_version}}</span>
                <span class="item-name text-center" v-if="site.vulnerability"><a class="view-vuls" :href="site.vulUrl" target="_blank">View vulnerability</a></span>
                <span class="item-name float-right" v-if="showUpdateStaging"><update-staging :entity="site" :updateType='`single`'  :siteName="site.siteName"></update-staging></span>

              </span>
              
            </div>
          </b-form-checkbox>
        </b-col>
      </b-row>
    </b-collapse>
  </div>

</template>

<script>
import Vue from 'vue';
import RightArrowIcon from "../../assets/rightarrow.svg";
export default {
  name: "updateItem",
  components: {
    RightArrowIcon,
    UpdateStaging :() =>
      import(/* webpackChunkName: 'Staging/index' */ '../addons/Staging/index').then(
        ({ UpdateStaging }) => UpdateStaging
      ),  
  },
  props: {
    entity: Object,
    hideselector: { type: Boolean, default: false },
    viewType:{
      type: String
    }
  },
  data() {
    return {
      show: false,
      specificEntity : [],
    };
  },
  methods: {
    shouldSelected(entity) {
      let selectedSites = _.filter(entity.sites, { selected: true });
      if (entity.sites.length === selectedSites.length) {
        return true;
      }
      return false;
    },
    toggleGroup(group, value) {
      this.$emit("toggleGroup", {
        group,
        value
      });
    },
    toggleSite(group, site, isSelected) {
      this.$emit("toggleSite", {
        group,
        site,
        isSelected
      });
    },
    onShow() {
      
      this.show = !this.show;
    },
    onHide() {
      this.show = false;
    },
    showSpecificEntity(index, existingEntity){
      if (typeof existingEntity != 'undefined' && existingEntity != null && existingEntity == true) {
        this.specificEntity[index] = false;
        this.$root.$emit('bv::toggle::collapse', index);
      }else{
        this.specificEntity[index] = true;
      }
      Vue.nextTick().then(() => {
        this.$forceUpdate();
      });
    },
  },
  computed:{
     showUpdateStaging(){
      if (typeof this.$store.getters.getSettings.staging != "undefined" &&  this.$store.getters.getSettings.staging.updateInStagingSwitchSettings == 1) {
          if(this.$route.params.slug == 'updates'){
            return true;
          }else{
            return false;
          }
      }else{
        return false;
      }
    }
  }
};
</script>

<style scoped>
.item-row {
  cursor: pointer;
}
.custom-control {
  width: auto;
}
.master-checkbox {
  margin-top: 7px;
  margin-left: 16px;
}
</style>
